let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4Z5Uh")).then(() => parcelRequire('f10rR'));